import Vue from 'vue'
import {
  FETCH_FILTERS_SETTINGS,
  FETCH_FILTER_DATA,
  SEND_FILTER_SELECTED,
  SEND_SEARCH_TIME,
} from './actions.type'
import {
  SET_FILTER_SETTINGS,
  FILTERS_RESET_STATE,
  SET_FILTER_DATA,
  SET_FILTER_SELECTED,
  SET_SEARCH_TIME,
} from './mutations.type'
import { FILTER_CONFIG } from '../config/filter_config'
import { FilterCall } from '@/common/api.service'

const initialState = FILTER_CONFIG

export const state = {
  ...initialState,
}

export const actions = {
  /**
   * Get a single service by id
   * @param {*} context
   * @param {*} payload
   */
  [FETCH_FILTERS_SETTINGS](context) {
    context.commit(SET_FILTER_SETTINGS, initialState)
    return
  },
  /**
   * Get a single service by id
   * @param {*} context
   * @param {*} payload
   */
  [SEND_FILTER_SELECTED](context, payload) {
    context.commit(SET_FILTER_SELECTED, payload)
    return
  },
  /**
   * Get from api a filters data in the filter settings
   * @param {*} context Vuex
   * @param {*} filterId The name of the api param
   * @returns
   */
  async [FETCH_FILTER_DATA](context, filterId) {
    const { data } = await FilterCall.get(filterId)
    context.commit(SET_FILTER_DATA, { data: data.content, filterId: filterId })
  },
  /**
   * Send time to set
   * @param {*} context
   * @param {*} payload
   */
  [SEND_SEARCH_TIME](context, payload) {
    context.commit(SET_SEARCH_TIME, payload)
    return
  },
}

/* eslint no-param-reassign: ["error", { "props": false }] */
export const mutations = {
  // Set filter data
  [SET_FILTER_DATA](state, payload) {
    const filterIndex = state.filterSettings.findIndex(
      (filter) => filter.apiParamName == payload.filterId
    )
    return (state.filterSettings[filterIndex].filterData = payload.data)
  },
  // Needed?
  [SET_FILTER_SETTINGS](state, settings) {
    return (state.filterConfig = settings)
  },
  // Set filters selected
  [SET_FILTER_SELECTED](state, payload) {
    const filterIndex = state.filterSettings.findIndex(
      (filter) => filter.paramId == payload.paramId
    )
    return (state.filterSettings[filterIndex].selected = payload.selected)
  },
  // Set filters selected
  [SET_SEARCH_TIME](state, payload) {
    return (state.lastSearch = payload)
  },

  // Reset
  [FILTERS_RESET_STATE]() {
    for (const f in state) {
      Vue.set(state, f, initialState[f])
    }
  },
}

export default {
  state,
  actions,
  mutations,
}
